import type {TableConfiguration} from 'schema/table/types';
import type {AgentWorkSummary} from 'services/agent/types';
import {workSummaryTableConfig} from './workSummaryTableConfig';

export const agentWorkSummaryTableConfig: TableConfiguration<AgentWorkSummary> =
  {
    ...workSummaryTableConfig,
    defaultColumns: [
      {
        name: 'roles',
        visible: true,
        width: 150,
      },
      ...(workSummaryTableConfig.defaultColumns ?? []),
    ],
  };
